import { normPixelToCanvas, normValueToPixel } from '../../Utils/PixelUtils'
import ColorUtils from '../../Utils/ColorUtils';

function drawPaths(allPaths, newPaths, context) {
    for (var path of newPaths) {
        context.strokeStyle = path.color;
        context.fillStyle = path.color;
        context.lineWidth = normValueToPixel(path.strokeSize, context.canvas.width);

        var points = path.points

        if (points.length === 1) {
            var { x, y } = normPixelToCanvas(points[0].x, points[0].y, context.canvas.width);
            context.beginPath();
            context.arc(x, y, context.lineWidth / 2, 0, 2 * Math.PI)
            context.fill();
        }

        for (var i = 1; i < points.length; i++) {
            context.beginPath();
            var startPoint = normPixelToCanvas(points[i - 1].x, points[i - 1].y, context.canvas.width);
            context.moveTo(startPoint.x, startPoint.y);
            var endPoint = normPixelToCanvas(points[i].x, points[i].y, context.canvas.width);
            context.lineTo(endPoint.x, endPoint.y);
            context.stroke();
        }
    }
}

function drawRandomColor(allPaths, newPaths, context) {
    for (var path of newPaths) {
        context.strokeStyle = ColorUtils.randomColor();
        context.lineWidth = normValueToPixel(path.strokeSize, context.canvas.width);

        if (!path.points.length) {
            continue;
        }

        context.beginPath();
        let { x, y } = normPixelToCanvas(path.points[0].x, path.points[0].y, context.canvas.width);
        context.moveTo(x, y);
        context.lineTo(x, y);
        for (var point of path.points.slice(1)) {
            let { x, y } = normPixelToCanvas(point.x, point.y, context.canvas.width);
            context.lineTo(x, y);
            context.stroke();
        }
        context.stroke();
    }
}

function drawRainbow(allPaths, newPaths, context) {
    for (var path of newPaths) {
        context.strokeStyle = ColorUtils.changeHue(path.color, allPaths[allPaths.length - 1].points.length * 5);
        context.lineWidth = normValueToPixel(path.strokeSize, context.canvas.width);

        if (!path.points.length) {
            continue;
        }

        context.beginPath();
        let { x, y } = normPixelToCanvas(path.points[0].x, path.points[0].y, context.canvas.width);
        context.moveTo(x, y);
        context.lineTo(x, y);
        for (var point of path.points.slice(1)) {
            let { x, y } = normPixelToCanvas(point.x, point.y, context.canvas.width);
            context.lineTo(x, y);
            context.stroke();
        }
        context.stroke();
    }
}

function drawPathsFromPathOrigin(allPaths, newPaths, context) {
    var startx = 0
    var starty = 0
    if (allPaths.length && allPaths[allPaths.length - 1].points.length) {
        startx = allPaths[allPaths.length - 1].points[0].x
        starty = allPaths[allPaths.length - 1].points[0].y
    }

    for (var path of newPaths) {
        context.strokeStyle = path.color;
        context.lineWidth = normValueToPixel(path.strokeSize, context.canvas.width);

        if (!path.points.length) {
            continue;
        }

        for (var point of path.points) {
            let { x, y } = normPixelToCanvas(point.x, point.y, context.canvas.width);
            context.beginPath();
            context.moveTo(normValueToPixel(startx, context.canvas.width), normValueToPixel(starty, context.canvas.width));
            context.lineTo(x, y);
            context.stroke();
        }
        context.stroke();
    }
}

function drawRainbowOrigin(allPaths, newPaths, context) {
    var startx = 0
    var starty = 0
    if (allPaths.length && allPaths[allPaths.length - 1].points.length) {
        startx = allPaths[allPaths.length - 1].points[0].x
        starty = allPaths[allPaths.length - 1].points[0].y
    }

    for (var path of newPaths) {
        context.strokeStyle = ColorUtils.changeHue(path.color, allPaths[allPaths.length - 1].points.length * 5);
        context.lineWidth = normValueToPixel(path.strokeSize, context.canvas.width);

        if (!path.points.length) {
            continue;
        }

        for (var point of path.points) {
            let { x, y } = normPixelToCanvas(point.x, point.y, context.canvas.width);
            context.beginPath();
            context.moveTo(normValueToPixel(startx, context.canvas.width), normValueToPixel(starty, context.canvas.width));
            context.lineTo(x, y);
            context.stroke();
        }
        context.stroke();
    }
}

export default function getDrawFunc(strategy) {
    if (strategy === 'origin') {
        return drawPathsFromPathOrigin;
    } else if (strategy === 'randcol') {
        return drawRandomColor;
    } else if (strategy === 'rainbow') {
        return drawRainbow;
    } else if (strategy === 'rainbow_origin') {
        return drawRainbowOrigin;
    }
    return drawPaths;
}